import {useRef} from 'react';
import {Link} from 'react-router';
import {Table, Popover} from 'antd';
import {TrashWidget} from "../widget/TrashWidget";
import {PurchaseOrderItemStatusWidget} from "../widget/PurchaseOrderItemStatusWidget";
import {InventoryAssignmentWidget} from "../fulfillment/InventoryAssignmentWidget";
import {toFSDateTime} from "../../util/timeutils";
import {getColumnSearchProps} from "../widget/SearchProps";
import {QuantityEntryWidget} from "../fulfillment/QuantityEntryWidget";
import {UnitType, PurchaseOrderItemStatusType} from "../../api/Constants";

export const PurchaseOrderLineItemTable = ({purchaseId, products, onDelete, onQuantityChange, onSelectAssign, onApiFail, refresh, onRefresh, isFulfillment=false, showLink=false, showState=false, props}) => {
    const onRowDelete = (index) => () => {
        if (onDelete) {
            onDelete(index, products[index]);
        }
    }

    const onAssignmentSelect = (record) => (val) => {
        if (onSelectAssign) {
            onSelectAssign(val, record.id);
        }
    }

    const quantityChange = (record) => (value) => {
        if (onQuantityChange) {
            onQuantityChange(record, value);
        }
    }

    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record, index) => {
                if (showLink === true) {
                    return <Link to={`/purchaseorder/${purchaseId}/lineItem/${record.id}`}>{val}</Link>
                }
                return val;
            },
            ...getColumnSearchProps("name", searchInput),
            sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (val, record) => {
                if ((record.state === undefined) || (record.state < PurchaseOrderItemStatusType.Complete)) {
                    return <QuantityEntryWidget title={'Update Quantity'} value={val} unit={UnitType.Each} placeholder={'quantity'} onQuantityChange={quantityChange(record)} />
                } else {
                    return <Popover content={`Quantity Can only be changed for items that are not completed yet.`}>{val}</Popover>;
                }
            }
        },
    ];

    if (showState) {
        columns.push({
            title: 'Status',
            dataIndex: 'state',
            key: 'state',
            render: (val, record, index) => {
                return <PurchaseOrderItemStatusWidget item={record} onApiFail={onApiFail} onRefresh={onRefresh} isFulfillment={isFulfillment}/>
            }
        })

        columns.push({
            title: 'Inventory',
            dataIndex: 'inventoryId',
            key: 'inventoryId',
            render: (val, record, index) => {
                return <InventoryAssignmentWidget productId={record.productId} refresh={refresh} onRefresh={onRefresh}
                  onApiFail={onApiFail} onSelect={onAssignmentSelect(record)} minQuantity={record.quantity}/>
            }
        })
    }

    if (onDelete !== undefined) {
        columns.push({
            title: 'Delete',
            dataIndex: 'name',
            key: 'delete',
            render: (val, record, index) => {
                const {completed, completedByUser, inventoryId} = record;
                // 8.27.2026
                // we test for inventoryId as well to find cases where the state is set
                // but no inventory is actually created.   We want to allow the delete button in this case
                if ((completedByUser) && (inventoryId !== null)) {
                    return <div>{`completed by ${completedByUser} on ${toFSDateTime(new Date(completed))}`}</div>
                }

                return <TrashWidget onDelete={onRowDelete(index)} />
            }
        });
    }

    return <Table dataSource={products} columns={columns} pagination={false} />
}